<template>
  <div class="row">
    <div class="col-sm-12" :class="{ 'col-md-6 col-xl-9': showAdvanced }">
      <div class="w-100">
        <h1>Applications</h1>

        <toolbar @advanced-search="toggleAdvancedSearch" />

        <search-table ref="searchTable" />
      </div>
    </div>

    <div v-if="showAdvanced" class="col-sm-12 col-md-6 col-xl-3">
      <advanced-search
        @error-message-changed="showErrorMessage"
        @reset-requested="reset"
        @close="toggleAdvancedSearch"
      />
    </div>
  </div>
</template>

<script>
import AdvancedSearch from './ApplicationsSearchAdvanced.vue';
import SearchTable from './ApplicationsSearchTable.vue';
import Toolbar from './ApplicationsToolbar.vue';

export default {
  name: 'ApplicationsList',
  components: {
    AdvancedSearch,
    SearchTable,
    Toolbar,
  },
  emits: ['toggle-advanced-search-applications'],
  data() {
    return {
      showAdvanced: false,
    };
  },
  methods: {
    toggleAdvancedSearch() {
      this.showAdvanced = !this.showAdvanced;
      this.emitter.emit('toggle-advanced-search-applications', this.showAdvanced);
    },
    showErrorMessage(msg) {
      this.$refs.searchTable.changeErrorMessage(msg);
    },
    reset() {
      this.$refs.searchTable.reset();
    },
  },
};
</script>
